import { render, staticRenderFns } from "./DashboardManagerV2.vue?vue&type=template&id=7b21a272&scoped=true"
import script from "./DashboardManagerV2.vue?vue&type=script&lang=js"
export * from "./DashboardManagerV2.vue?vue&type=script&lang=js"
import style0 from "./DashboardManagerV2.vue?vue&type=style&index=0&id=7b21a272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b21a272",
  null
  
)

export default component.exports